import React from 'react';
import { Text } from '@miro-site/ui-design-system';
import { NavButton } from '../components/nav-button';
import { getNavSideBarItemTransitionDelay } from './get-nav-side-bar-item-transition-delay';
import { Separator } from '../components/separator';
import { jsx as _jsx } from "react/jsx-runtime";
export var SIDE_BAR_LEVEL;

(function (SIDE_BAR_LEVEL) {
  SIDE_BAR_LEVEL[SIDE_BAR_LEVEL["FIRST"] = 0] = "FIRST";
  SIDE_BAR_LEVEL[SIDE_BAR_LEVEL["SECOND"] = 1] = "SECOND";
})(SIDE_BAR_LEVEL || (SIDE_BAR_LEVEL = {}));

export var SIDE_BAR_ELEMENT;

(function (SIDE_BAR_ELEMENT) {
  SIDE_BAR_ELEMENT[SIDE_BAR_ELEMENT["NAV_BUTTON"] = 0] = "NAV_BUTTON";
  SIDE_BAR_ELEMENT[SIDE_BAR_ELEMENT["NAV_LINK"] = 1] = "NAV_LINK";
  SIDE_BAR_ELEMENT[SIDE_BAR_ELEMENT["SEPARATOR"] = 2] = "SEPARATOR";
  SIDE_BAR_ELEMENT[SIDE_BAR_ELEMENT["GROUP_TITLE"] = 3] = "GROUP_TITLE";
})(SIDE_BAR_ELEMENT || (SIDE_BAR_ELEMENT = {}));

export var getSideBarItems = function getSideBarItems(_ref) {
  var items = _ref.items,
      selectItem = _ref.selectItem,
      _ref$isAnimated = _ref.isAnimated,
      isAnimated = _ref$isAnimated === void 0 ? true : _ref$isAnimated;
  return items.map(function (item) {
    var style = {
      transitionDelay: item.transitionDelay
    };

    switch (item.type) {
      case SIDE_BAR_ELEMENT.NAV_BUTTON:
        return /*#__PURE__*/_jsx(NavButton, {
          title: item.title,
          selectItem: selectItem,
          showChevron: true,
          style: style
        }, item.title);

      case SIDE_BAR_ELEMENT.NAV_LINK:
        return /*#__PURE__*/_jsx(NavButton, {
          image: item.image,
          title: item.title,
          path: item.path,
          style: style
        }, item.title);

      case SIDE_BAR_ELEMENT.SEPARATOR:
        return /*#__PURE__*/_jsx(Separator, {
          isAnimated: isAnimated,
          style: style,
          className: "my-100"
        }, item.key);

      case SIDE_BAR_ELEMENT.GROUP_TITLE:
        return /*#__PURE__*/_jsx(Text, {
          as: "p",
          className: "category text-secondary",
          renderChildrenAsHTML: true,
          children: item.title
        }, item.title);

      default:
        return null;
    }
  });
};
export var flattenSideBarGroups = function flattenSideBarGroups(groups, sideBarLevel) {
  var itemCount = 0;
  return groups.reduce(function (accumulator, group, groupIndex) {
    var shouldOutputDivider = groups.length - 1 !== groupIndex;
    var isFirstLevel = sideBarLevel === SIDE_BAR_LEVEL.FIRST;

    if (isFirstLevel) {
      ;
      group.forEach(function (item) {
        var _item$groups;

        var hasChildren = Number(item === null || item === void 0 ? void 0 : (_item$groups = item['groups']) === null || _item$groups === void 0 ? void 0 : _item$groups.length) > 0;
        accumulator.push({
          type: hasChildren ? SIDE_BAR_ELEMENT.NAV_BUTTON : SIDE_BAR_ELEMENT.NAV_LINK,
          title: item.title,
          path: item.path,
          transitionDelay: getNavSideBarItemTransitionDelay(++itemCount)
        });
      });
    }

    if (!isFirstLevel) {
      var _group$items;

      accumulator.push({
        type: SIDE_BAR_ELEMENT.GROUP_TITLE,
        title: "".concat(group['title']),
        transitionDelay: getNavSideBarItemTransitionDelay(++itemCount)
      });
      group === null || group === void 0 ? void 0 : (_group$items = group['items']) === null || _group$items === void 0 ? void 0 : _group$items.forEach(function (item) {
        accumulator.push({
          type: SIDE_BAR_ELEMENT.NAV_LINK,
          title: item.title,
          path: item.path,
          image: item.image,
          transitionDelay: getNavSideBarItemTransitionDelay(++itemCount)
        });
      });
    }

    if (shouldOutputDivider) {
      /**
       * Add a divider if the group is not the last group in the menu
       */
      accumulator.push({
        key: "".concat(groups.length, "-").concat(groupIndex),
        type: SIDE_BAR_ELEMENT.SEPARATOR,
        transitionDelay: getNavSideBarItemTransitionDelay(++itemCount)
      });
    }

    return accumulator;
  }, []);
};